import React, { Component } from "react"
import Deck from './Deck'


//The big white square with the words in it
class Cards extends Component {
  //give properties to react component constructor
  constructor(props) {
    super(props);
    this.lang = this.props.match.params.lang;
    let data;
    if (this.lang === 'rus') {
      data = require('../static/rus.json')
    } else {
      data = require('../static/esp.json')
    }

    this.cards = [];
    //copy of all cards for deckifying
    this.all = [];
    let i;
    for (i = 0; i < data.length; i++) {
      this.cards.push(data[i]);
      this.all.push(data[i]);
    }

    //card text and position number text
    //goes in div
    this.state = {
      decks: []
    };
    this.goTo = null;
    this.cardDiv = null;
    this.posDiv = null;
    this.searchTerm = null;
    //array of all possible cards
    //current card index
    this.i = 0;
    //are we on the eng side? 
    //either bc eng side up or bc flipped
    this.isEng = true;
    //card was flipped
    this.flipped = false;

    //don't sort more than once
    this.sorted = false;

    this.update = this.update.bind(this);
    this.flip = this.flip.bind(this);
    this.next = this.next.bind(this);
    this.switchLang = this.switchLang.bind(this);
    this.deckify = this.deckify.bind(this);
    this.goToPos = this.goToPos.bind(this);
    this.flipdate = this.flipdate.bind(this);
    this.search = this.search.bind(this)

  }

  //pick the esp or eng side of the card at 
  //current index and update the text
  update() {
    if (this.cardDiv !== null) {
      console.log(this.cardDiv.innerHTML)
      console.log(this.cards[this.i].eng)

      this.cardDiv.innerHTML = this.isEng ? this.cards[this.i].tran : this.cards[this.i].eng;
      this.posDiv.innerHTML = (this.i + 1) + "/" + this.cards.length;
    }
  }

  //swap sides and update
  flip() {
    this.isEng = !this.isEng;
    this.flipped = !this.flipped;
    this.update();
  }

  //move the card index forward or back 
  next(amt) {
    this.i = (this.i + amt) % this.cards.length;
    //wrap around
    if (this.i < 0) {
      this.i = this.cards.length - 1;
    }
    //if you flipped over the card last time,
    //this one shouldn't be flipped too
    this.flipdate();

  }


  //flip sides before updating or no
  //for when deck or language changes
  flipdate() {
    if (this.flipped) {
      this.flip()
    } else {
      this.update();
    }
  }

  //take all the cars and split them into decks 
  //with 10 cards each
  deckify() {
    var i;

    //fill array with deck components
    var links = [];
    for (i = 10; i < this.all.length; i += 10) {
      links.push(<Deck name={i} key={i} cards={this} />);
    }
    //go back to first deck
    this.changeDeck(10);
    this.setState({ decks: links })
  }

  //change the card to be 10 cards from index - 10
  //to index
  changeDeck(index) {
    //empty current cards
    this.cards = [];
    var i;
    for (i = index - 10; i < index; i++) {
      this.cards.push(this.all[i]);
    }
    this.i = 0;
    this.flipdate();
  }

  //change all cards to be other language side up
  switchLang() {
    this.isEng = !this.isEng;
    this.update();
  }

  goToPos() {
    this.i = parseInt(this.goTo.value) - 1;
    this.update();
  }

  //build a deck of all that contain search term
  search() {
    console.log("meh");
    let i;
    this.cards = [];
    for (i = 0; i < this.all.length; i++) {
      if (this.all[i].tran.toLowerCase().includes(this.searchTerm.value) ||
        this.all[i].eng.toLowerCase().includes(this.searchTerm.value)) {
        this.cards.push(this.all[i]);
      }
    }
    this.update();
  }

  //if this react component was made successfully
  //then add click handlers to the card div and buttons
  componentDidMount() {
    this.cardDiv = document.getElementById("cardDiv");
    this.posDiv = document.getElementById("posText");
    this.decks = document.getElementById("decks");
    this.goTo = document.getElementById("goInput");
    this.searchTerm = document.getElementById("searchInput");
    this.update();
  }

  //this is what card and buttons should look like
  //StaticQuery is the query to get the json info
  render() {
    return (
      <div>
        <img id="bkg" src={this.lang === 'rus' ? "../rusBkg.jpeg" : "../espBkg.jpg"} alt="bkg" />
        <center>
          <br />
          <button type="button" onClick={() => this.next(-1)}>{this.lang === 'rus' ? 'прошлая' : 'Previa'}</button>
          <p className="pos" id="posText"></p>
          <button type="button" onClick={() => this.next(1)}>{this.lang === 'rus' ? 'следующая' : 'Próxima'} </button>
          <div className="cardText" id="cardDiv" onClick={this.flip}>
          </div>
          <div>
            <input type="number" id="goInput" defaultValue="1" min="1" max={this.cards.length} />
            <button type="button" onClick={this.goToPos}>{this.lang === 'rus' ? 'давай!' : '¡Vamonos!'}</button>
            <input type="text" id="searchInput" defaultValue="..." min="1" />
            <button type="button" onClick={this.search}>{this.lang === 'rus' ? 'найти!' : '¡Buscar!'}</button>
            <button type="button" onClick={this.deckify}>{this.lang === 'rus' ? 'сортировать' : 'Ordenar'}</button>
            <button type="button" onClick={this.switchLang}>{this.lang === 'rus' ? 'рус - анг' : "esp - ing"}</button>
            <br />
            <div id="decks">
              {this.state.decks}
            </div>
          </div>
        </center>
      </div>
    )
  }
}

export default Cards;